import React from 'react'
import RuleCreateBatchPage from './RuleCreateBatchPage'
import '../styles/index.scss'

function RuleCreateBatchContainer() {
    return (
        <div className='RuleCreateBatchContainer'>
            <RuleCreateBatchPage />
        </div>
    )
}

export default RuleCreateBatchContainer